import React, { useState, useContext, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AccountContext } from "../contexts/AccountContext";
import VerticalNav from "../components/VerticalNav";
import _axios from "../axios";
import buildLink from "../urls";
import { FaDigitalTachograph, FaSms } from "react-icons/fa";
import PhoneHandler from "../components/PhoneHandler";
import ChangePassword from "./ChangePassword";
import Loader from "../components/Loader";
import AccountHeader from "../components/AccountHeader";
import { toast } from "react-toastify";
import PopUp from "../components/Popup";
import { MdVerified } from "react-icons/md";
export default function Profile() {
  const [stateAccount, dispatchAccount] = useContext(AccountContext);
  const [accountInfo, setAccountInfo] = useState();
  const [error, setError] = useState();
  const [showDeletePopUp, SetShowDeletePopUp] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [codeSection, setCodeSection] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  let code = "";
  const [verified, setVerified] = useState({
    isVerfied: false,
    phoneNumber: null,
  });

  const [isvalid, setIsValid] = useState();

  const fnameRef = useRef("");
  const lnameRef = useRef("");
  const phoneRef = useRef(null);
  const dateOfBirthRef = useRef("");
  const femail = useRef("");
  let verificationCode = ["", "", "", "", "", ""];
  const verificationCodeRefs = [
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ];
  let isPast = false;

  const navigate = useNavigate();

  console.log(stateAccount.loged);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAccount();
  }, [window.location.href]);

  const handleCodeChange = (index, value) => {
    if (!isPast) {
      verificationCodeRefs[index].current.value = value;
      if (value !== "" && index < verificationCode.length - 1) {
        verificationCodeRefs[index + 1].current.focus();
      }
      handleVerifyCode();
    }
  };

  const phoneHanlder = (childData, isValid) => {
    if (phoneRef.current) {
      phoneRef.current.value = childData;
    }

    setIsValid(isValid);
  };

  async function getAccount() {
    _axios
      .get(buildLink("get_account", undefined, window.innerWidth))
      .then((response) => {
        if (!response.data.success) {
          dispatchAccount({ type: "setLoading", payload: false });
          if (!stateAccount.loading && !stateAccount.loged) {
            navigate("/");
          }
        } else {
          console.log(response?.data?.data);
          setAccountInfo(response?.data?.data);
          dispatchAccount({
            type: "setEmail",
            payload: response?.data?.data?.email,
          });
          setVerified((prev) => ({
            ...prev,
            isVerfied: response?.data?.data?.verified,
            phoneNumber: response?.data?.data?.telephone,
          }));
          // dispatchAccount({
          //   type:"sethasDateBirth",
          //   payload:  response?.data?.data?.date_of_birth !== "" ? true : false,
          // })
        }
      });
  }

  function showError() {
    // turn it on
    setErrorMessage(true);

    // after 3 seconds, turn it off
    setTimeout(() => {
      setErrorMessage(false);
    }, 3000);
  }

  const handleVerifyCode = async () => {
    verificationCodeRefs.map(
      (item, index) => (verificationCode[index] = item.current.value)
    );

    const code = verificationCode.join("");

    if (code.toString().length === 6) {
      console.log("chadi")
      const obj = {
        customer_id: stateAccount.userId,
        verification_code: code,
      };
      setLoadingVerify(true);

      await _axios
        .post(buildLink("CustomerPhoneVerification"), obj)
        .then((res) => {
          setLoadingVerify(false);

          if (res.data.success) {
            setCodeSection(false);
            setOpenModal(false);
            let phoneNumber = phoneRef?.current?.value;
            setVerified((prev) => ({
              ...prev,
              isVerfied: true,
              phoneNumber: phoneNumber,
            }));
          } else {
            toast(res.data.message, { type: "error" });
          }
        });
    } else {
      // toast('Please enter a 6 digit code', { type: 'error' });
    }
  };

  async function CustomerPhoneVerification() {
    console.log('chadi')
    if (phoneRef.current.value) {
      const obj = {
        customer_id: stateAccount.userId,
        telephone: phoneRef.current.value,
      };
      setLoadingVerify(true);
      await _axios
        .post(buildLink("CustomerPhoneVerification"), obj)
        .then((res) => {
          if (res.data.success) {
            setCodeSection(true);
            code = res.data.code;
            verificationCodeRefs[0].current.focus();
            setLoadingVerify(false);
          } else {
            toast(res.data.message);
            setOpenModal(false);
            setLoadingVerify(false);
          }
        });
    }
  }

  function saveDetails(event) {
    event.preventDefault();

    if(accountInfo?.telephone==="" && !verified?.isVerfied){
      showError();
      return
    }

    var obj = {
      firstname: fnameRef.current.value,
      lastname: lnameRef.current.value,
      email: femail.current.value,
      date_of_birth: dateOfBirthRef.current.value,
    };
    if (verified.isVerfied &&  verified?.phoneNumber !== "") {
      obj.telephone = verified?.phoneNumber
      obj.verified = 1;
    }

    _axios
      .put(buildLink("save_account", undefined, window.innerWidth), obj)
      .then((response) => {
        if (!response.data.success) {
          setError(response?.data?.errors[0]);
        } else {
          setError("");
          toast("Account Updated Successffully", { type: "success" });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      });
  }

  const handlePasteCode = (e) => {
    isPast = true;
    const pastedCode = e.clipboardData.getData("text/plain");
    // console.log(pastedCode);

    // Validate that the pasted code is numeric and has the correct length
    if (/^\d{6}$/.test(pastedCode)) {
      const newVerificationCode = pastedCode
        .split("")
        .slice(0, verificationCode.length);
      verificationCodeRefs.map(
        (item, index) => (item.current.value = newVerificationCode[index])
      );
      handleVerifyCode();
    }
  };

  function disabledAccount() {
    //e.preventDefault();
    _axios
      .post(buildLink("disabledAccount", undefined, window.innerWidth))
      .then((response) => {
        if (response.data.success) {
          logout();
          window.location.href = "/";
        }
      });
  }

  function logout() {
    _axios.post(buildLink("logout")).then(() => {});
  }

  return (
    <div className={`bg-dgrey10 py-5 px-4 md:px-6 lg:px-12`}>
      {!accountInfo ? (
        <Loader />
      ) : (
        <>
          {/* <AccountHeader stateAccount={stateAccount} /> */}
          <div className="flex mt-2 gap-5 text-left">
            {/* {window.innerWidth > 650 && (
          <div className="w-1/2">
            <VerticalNav />
          </div>
        )} */}
            <div className="w-full">
              <form
                onSubmit={(e) => saveDetails(e)}
                className="bg-white rounded-lg shadow-md p-6"
              >
                <div className="font-semibold text-black flex justify-between">
                  <h2 className="text-xl font-semibold mb-1">Profile</h2>
                  {window.innerWidth > 650 && (
                    <div className="flex justify-end">
                      <button
                        className="bg-dbase text-white px-6 lg:py-2 lg:mb-0 py-1 mb-2 rounded-md text-d14"
                        type="button"
                        onClick={(e) => {
                          SetShowDeletePopUp(true);
                        }}
                      >
                        DELETE ACCOUNT
                      </button>
                    </div>
                  )}
                </div>
                <p className="text-sm text-gray-500 mb-6">
                  Manage your profile informations
                </p>

                <div className="mb-4 font-semibold text-black flex justify-between">
                  <span>General</span>
                </div>

                <div className="grid md:grid-cols-2 lg:gap-6  gap-3">
                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      First Name
                    </label>
                    <input
                      type="text"
                      ref={fnameRef}
                      defaultValue={accountInfo?.firstname}
                      className="w-full border border-gray-300 rounded-md px-3 py-2"
                    />
                    {error?.errorCode === "firstname" && (
                      <div className="text-red-600 text-sm mt-1">
                        {error.errorMsg}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      Last Name
                    </label>
                    <input
                      ref={lnameRef}
                      defaultValue={accountInfo?.lastname}
                      className="w-full border border-gray-300 rounded-md px-3 py-2"
                    />
                    {error?.errorCode === "lastname" && (
                      <div className="text-red-600 text-sm mt-1">
                        {error.errorMsg}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      ref={femail}
                      defaultValue={accountInfo?.email}
                      className="w-full border border-gray-300 rounded-md px-3 py-2"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label className="text-dlabelColor">
                      Phone Number{" "}
                      {!accountInfo.telephone && (
                        <span className="text-dborderblack1 pr-semibold">
                          ( Required ) *
                        </span>
                      )}
                    </label>
                    <div
                      className={`ring-opacity-25 ${
                        accountInfo.verified ? "" : "ring-dborderblack2 ring-4"
                      } relative overflow-hidden border-opacity-40 border border-[#d5d5d5] flex flex-row w-full bg-[#f2f2f2] bg-opacity-25 rounded-md`}
                    >
                      <input
                        ref={phoneRef}
                        defaultValue={accountInfo.telephone}
                        readOnly={verified?.isVerfied}
                        required
                        placeholder="Enter your phone number"
                        className="my-auto custom-cursor-color placeholder:text-[#cecece] w-full h-full px-4 bg-transparent outline-none border-none"
                      />
                      {verified?.isVerfied ? (
                        <div className="w-20 h-full py-3 bg-dgreen transition-all flex justify-center">
                          <MdVerified className="text-white" />
                        </div>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            if (phoneRef.current.value !== "") {
                              setCodeSection(false)
                              setOpenModal(true);
                            } else {
                              showError();
                            }
                          }}
                          className="w-20 h-full py-2 bg-[#e4e4e4] text-dborderblack1 hover:bg-dborderblack1 hover:text-white transition-all flex justify-center"
                        >
                          <div className="relative">Verify</div>
                        </button>
                      )}
                    </div>
                  </div>

                  

                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      Date of birth
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        ref={dateOfBirthRef}
                        max={new Date().toISOString().split("T")[0]}
                        defaultValue={accountInfo?.date_of_birth}
                        onClick={(e) =>
                          e.target.showPicker && e.target.showPicker()
                        } // for browsers that support it
                        disabled={!!accountInfo?.date_of_birth}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 pr-10 bg-white"
                      />
                      <span className="absolute top-2.5 right-3 text-gray-500">
                        <i className="fa fa-calendar" />
                      </span>
                    </div>
                  </div>
                  <div className=" md:mt-6 flex md:justify-end justify-center">
                    <button className={`bg-dborderblack1 text-white  py-2 rounded-md text-d15 px-6   lg:mb-0`}>
                      SAVE
                    </button>
                  </div>
                  {window.innerWidth < 650 && (
                    <div className="flex justify-center">
                      <button
                        className="bg-dbase text-white px-6 py-2 md:mb-0 mb-2 rounded-md text-d14"
                        type="button"
                        onClick={(e) => {
                          SetShowDeletePopUp(true);
                        }}
                      >
                        DELETE ACCOUNT
                      </button>
                    </div>
                  )}
                </div>
                {errorMessage &&(
                  <span className="w-full text-sm text-dbase capitalize">
                    Please Enter and verify Your phone number before saving details
                  </span>
                )}
              </form>
              
            </div>
          </div>

          <PopUp
            isOpen={showDeletePopUp}
            onClose={() => SetShowDeletePopUp(false)}
            title="Delete Your Account"
          >
            <div className="w-full h-full flex flex-col items-center justify-center gap-6 text-center px-4 py-6">
              <p className="text-dlabelColor text-base md:text-lg font-medium">
                Are you sure you want to delete your account?
              </p>

              <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
                <button
                  onClick={() => SetShowDeletePopUp(false)}
                  className="bg-gray-300 hover:bg-gray-400 text-black px-6 py-2 rounded-lg text-base font-semibold transition"
                >
                  Cancel
                </button>

                <button
                  onClick={disabledAccount}
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-base font-semibold transition"
                >
                  Delete
                </button>
              </div>
            </div>
          </PopUp>
        </>
      )}

      {openModal && (
        <PopUp 
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
        >
           <div className="w-full relative">
              <div className="w-fit py-4 mx-auto">
                <FaSms className="text-[70px] text-dborderblack1" />
              </div>
              <div
                className={`${
                  codeSection && "hidden" 
                }  transition-all `}
              >
                <div className="w-full h-full  relative justify-center text-center flex flex-col gap-4">
                  <div className="mx-auto">
                    <h2 className="font-bold text-2xl">
                      Send Verification Code
                    </h2>
                    <span className="mt-4">
                      Are you sure you want to verify the number{" "}
                    </span>
                    <button
                      onClick={() => CustomerPhoneVerification()}
                      className="mt-8 w-full border border-dborderblack1 rounded-md text-dborderblack1 py-3 bg-white hover:bg-dborderblack2 flex flex-row justify-center gap-5 hover:text-white transition-all"
                    >
                      <span>Send </span>
                      {loadingVerify && (
                        <div className="w-6 h-6">
                          <Loader />
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div
                className={`${
                  !codeSection && "hidden"
                }  w-full h-full transition-all`}
              >
                <div className="flex justify-center text-center">
                  <div className="my-auto w-full mx-auto">
                    <h2 className="font-bold text-2xl">
                      Phone Number Validation
                    </h2>
                    <span className="mt-4">Enter the code sent to</span>
                    <div className="w-fit mx-auto gap-2 mt-5 flex flex-row">
                      {verificationCode.map((digit, index) => (
                        <input
                          className="w-10 py-2 text-center bg-dgrey rounded-md border border-dborderblack1"
                          key={index}
                          type="text"
                          maxLength="1"
                          onChange={(e) =>
                            handleCodeChange(index, e.target.value)
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" && index > 0) {
                              if (e.target.value === "") {
                                verificationCodeRefs[index - 1].current.focus();
                              } else {
                                verificationCodeRefs[index].current.value = "";
                              }
                            }
                          }}
                          onPaste={(e) => handlePasteCode(e)}
                          ref={verificationCodeRefs[index]}
                        />
                      ))}
                    </div>
                    <div className="w-full flex flex-row gap-2">
                      <button
                        onClick={() => handleVerifyCode()}
                        className="mt-8 w-full border border-dborderblack1 rounded-md text-dborderblack1 py-3 bg-white hover:bg-dborderblack2 flex flex-row justify-center gap-5 hover:text-white transition-all"
                      >
                        <span>Submit </span>
                        {loadingVerify && (
                          <div className="w-6 h-6">
                            <Loader />
                          </div>
                        )}
                      </button>
                      <button
                        onClick={() => {
                          setOpenModal(false);
                          setCodeSection(false);
                        }}
                        className="mt-8 w-full hover:bg-white hover:text-dborderblack1 rounded-md text-white py-3 bg-dborderblack1 hover:bg-dbase1 transition-all"
                      >
                        <span>Cancel </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </PopUp>
      )}
    </div>
  );
}
